// Web Push helper - free native phone/desktop notifications via the installed app.
import { api } from "@/lib/api";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

// Subscribe this device for push and register it with the backend.
export async function enablePush() {
  if (!pushSupported()) throw new Error("Push isn't supported in this browser. On iPhone, install the app first (Share -> Add to Home Screen).");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notifications were blocked. Enable them in your browser settings and try again.");
  const registration = await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/public-key");
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.publicKey),
  });
  await api.post("/push/subscribe", { subscription: subscription.toJSON(), userAgent: navigator.userAgent });
  return subscription;
}

// Unsubscribe this device and deregister it from the backend.
export async function disablePush() {
  if (!pushSupported()) return;
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (subscription) {
    await api.post("/push/unsubscribe", { endpoint: subscription.endpoint }).catch(() => {});
    await subscription.unsubscribe().catch(() => {});
  }
}

export async function sendTestPush() {
  const { data } = await api.post("/push/test");
  return data.sent;
}
